<p-confirmDialog key="pbis" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PBISEnabledDesc-->
				<th>
					<p-columnFilter field="PBISEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPBISEnabledDesc
								[ngModel]="value"
								[options]="lstPBISEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="PBISEnabledDesc">Show PBIS<p-sortIcon field="PBISEnabledDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School" (dblclick)="onRowDblClick(School)">
				<td>
					<p-tableCheckbox [disabled]="loading == true" [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ School[col.field] }}
				</td>

				<td [style.color]="School.PBISEnabled == true ? 'Limegreen' : 'Red'" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ School.PBISEnabledDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="loading" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
	<button [disabled]="loading" class="btn btn-success LeftMargin" (click)="onEnable()">Enable</button>
	<button [disabled]="loading" class="btn btn-warning LeftMargin" (click)="onDisable()">Disable</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
